import moment, { Moment } from 'moment'

import { RootState } from '../../../store'
import { ICalendarDay } from '../../types'
import { getStartAndEndDate } from '../../utils'

export const filterEventsBySelectedDateRange = (
  state: RootState,
  selectedDate: Moment,
  amountOfDays: number,
): { [key: string]: ICalendarDay } =>
  Object.keys(state.calendarNew.eventsByDay)
    .filter((key: string) => {
      const dateOfKey = moment(key).startOf('day')
      const dateRange = getStartAndEndDate(selectedDate, amountOfDays)

      return dateOfKey.isBetween(dateRange.start, dateRange.end, 'day', '[]')
    })
    .reduce((accumulated: { [key: string]: ICalendarDay }, key: string) => {
      // eslint-disable-next-line no-param-reassign
      accumulated[key] = state.calendarNew.eventsByDay[key]

      return accumulated
    }, {})
